import React from 'react';
import { Container } from 'react-bootstrap';
import { ResourceImage } from '.';
import { ROUTE_PATHS } from '../utils';
import { SunSetNotificationHCPPortalURLS, SunsetNotificationMessage } from '../utils/constants';
import { Link } from 'react-router-dom';
import { CustomThemes } from '../utils/custom-themes';

export const LogoToolbar = () => {
  const SunSetHCPPortalNotification = SunSetNotificationHCPPortalURLS;
  const hostname = window.location.hostname;
  const showNotificationComponent = SunSetHCPPortalNotification.includes(hostname);
  CustomThemes();
  return (
    <Container fluid className='cmx__logo-toolbar'>
      <Container
        className='d-flex justify-content-center justify-content-md-start align-items-center flex-wrap flex-md-nowrap'
        style={{ columnGap: '2rem', rowGap: '0.75rem' }}>
        <Link to={ROUTE_PATHS.login} style={{ flexShrink: 0 }}>
          <ResourceImage contentKey='header.logo' className='cmx__logo-toolbar__image pointer' />
        </Link>
        {showNotificationComponent && (
          <div className='notfication_component'>
            <strong>{SunsetNotificationMessage}</strong>
          </div>
        )}
      </Container>
    </Container>
  );
};
